import { runtime } from '@codeArt/common';
import { wrap,map } from '@codeArt/utils/promise';
import { type } from '../utils/common';
import { Context } from './context';
import { Runtime } from './runtime';
import { Contribution } from './contribution';

const _ = require("lodash");
function Host(){

    const _context = new Context();
    this.context = ()=> _context;

    const _contribution = new Contribution();
    this.contribute = ()=> _contribution;
    
    const _runtime = new Runtime();
    this.runtime = ()=> _runtime;

    let _plugins = [];

    this.register = (plugins)=>{  //注册插件
        if(!plugins || plugins.length===0) return;
        if(type(plugins) !=="array") plugins=[plugins];
        _plugins = _plugins.concat(plugins);
    }

    
    this.getPlugins= (ignoreFilter)=>{ //获得全部已注册的插件信息，忽略过滤
        return ignoreFilter ? _plugins : getValidPlugins();
    }

    this.getPlugin= ({id,ignoreFilter})=>{
        let plugins = this.getPlugins(ignoreFilter);
        return _.find(plugins,(p)=> p.id===id);
    }

    let _filterPlugins = null;
    this.filter = (predicate)=>{ //根据过滤器，过滤插件，只有满足条件的插件才会被使用
        if(predicate===false){  //取消过滤
            _filterPlugins=null;
            return;
        }
        _filterPlugins = _.filter(_plugins,predicate);
    }

    const getValidPlugins = ()=> _filterPlugins ?? _plugins; //如果有过滤，就用过滤后的插件

    const findValidPlugins=(event)=>{
        let plugins = getValidPlugins();
        return _.filter(plugins,(p)=>  _.find(p.activationEvents,(e)=> e===event ));
    }

    const findValidPluginByIds=(ids)=>{
        let plugins = getValidPlugins();
        return _.filter(plugins,(p)=>  _.find(ids,(id)=> p.id===id ));
    }

    this.activate = ({event,ids})=>{//基于事件，激活插件
        let plugins = event ? findValidPlugins(event) : findValidPluginByIds(ids);
        return _activateExtensions(plugins);
    }
    
    const _activateExtensions = (plugins)=>{
        const ctx = _context.get();
        return wrap((resolve, reject) => {
            Promise.all(plugins.map((plugin)=>loadPlugin(plugin,ctx))).then((getDeactivates)=>{
                const deactivate = () => Promise.all(getDeactivates.map((get)=> get()));
                resolve(deactivate);
            }).catch(reject);
        });
    }

    const loadPlugin = (plugin,ctx)=>{
        const {id,main} = plugin;
        return wrap((resolve, reject) => {
            main().then(({activate,deactivate})=>{  //执行插件的main方法，加载插件代码
                execActivate(plugin,{activate,deactivate},ctx).then(()=>{
                    resolve(()=> execDeactivate(id));    //将此方法作为释放函数返回给外部
                });
            }).catch(reject);
        });
    }

    const execActivate = (plugin,{activate,deactivate},ctx)=>{ //执行插件的激活函数
        const {id} = plugin;
        return wrap((resolve, reject) => {
            _contribution.dispatch(plugin).then((exacts)=>{   //激活之前，先处理贡献点
                map(activate,ctx).then((exports)=>{
                    _runtime.addExtension(id,{ //激活后，将插件的实例放入到运行时中
                        exports,
                        exacts,     //撤回贡献点
                        deactivate  //定义的销毁函数
                    });
                    resolve();
                }).catch(reject);
            }).catch(reject);
        });
    }

    const execDeactivate = (id)=>{ //销毁插件
        return _runtime.removeExtension(id);
    }
}

export {Host};